'use client'

import classNames from 'clsx'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import JoinArenaArrow from '@/assets/icons/join-arena-arrow.svg'
import { URLS } from '@/configs/urls'
import { Link } from '@/i18n/routing'

import {
  ARROWS_IMG,
  CAMERA_IMG,
  DIALOG_BOX_IMG,
  EYE_IMG,
  FIRE_IMG,
  REWARDS_CARD_COPY
} from '../fansLandingContent.constants'
import S from './FansRewardsWays.module.scss'

const FansRewardsWays = () => {
  const t = useTranslations('fansPage.hero')

  return (
    <>
      <div className={S.rewardsWaysIntro}>
        <p className={S.rewardsWaysEyebrow}>{t('rewardsWaysEyebrow')}</p>
        <div className={S.rewardsWaysHeadlineCluster}>
          <div className={S.rewardsWaysHeadlineGlow} aria-hidden />
          <p className={S.rewardsWaysHeadline}>{t('rewardsWaysHeadline')}</p>
        </div>
      </div>
      <div className={S.rewardsWaysCards}>
        {REWARDS_CARD_COPY.map((card, index) => (
          <div
            key={card.levelKey}
            className={classNames(
              S.rewardsWaysCard,
              card.cardClassName && S[card.cardClassName]
            )}
          >
            <div className={S.rewardsWaysCardIconBox} aria-hidden>
              {index === 0 && (
                <div className={S.rewardsWaysCardIconEye}>
                  <Image
                    src={EYE_IMG}
                    alt=""
                    fill
                    sizes="56px"
                    className={S.rewardsWaysCardIconImage}
                  />
                </div>
              )}
              {index === 1 && (
                <div className={S.rewardsWaysCardIconArrows}>
                  <Image
                    src={ARROWS_IMG}
                    alt=""
                    fill
                    sizes="56px"
                    className={S.rewardsWaysCardIconImage}
                  />
                </div>
              )}
              {index === 2 && (
                <div className={S.rewardsWaysCardIconDialogBox}>
                  <Image
                    src={DIALOG_BOX_IMG}
                    alt=""
                    fill
                    sizes="56px"
                    className={S.rewardsWaysCardIconImage}
                  />
                </div>
              )}
              {index === 3 && (
                <div className={S.rewardsWaysCardIconCamera}>
                  <Image
                    src={CAMERA_IMG}
                    alt=""
                    fill
                    sizes="56px"
                    className={S.rewardsWaysCardIconImage}
                  />
                </div>
              )}
              {index === 4 && (
                <div className={S.rewardsWaysCardIconFire}>
                  <Image
                    src={FIRE_IMG}
                    alt=""
                    fill
                    sizes="56px"
                    className={S.rewardsWaysCardIconImage}
                  />
                </div>
              )}
            </div>
            <div className={S.rewardsWaysCardContent}>
              <p className={S.rewardsWaysCardTitle}>{t(card.titleKey)}</p>
              <p className={S.rewardsWaysCardDescription}>{t(card.bodyKey)}</p>
            </div>
            <p
              className={classNames(
                S.rewardsWaysCardLevel,
                S[card.levelClassName]
              )}
            >
              {t(card.levelKey)}
            </p>
            <div className={S.rewardsWaysCardNoise} aria-hidden />
          </div>
        ))}
      </div>
      <Link href={URLS.CHALLENGES} className={S.exploreAllChallengesCta}>
        {t('exploreAllChallenges')}
        <JoinArenaArrow className={S.joinCtaArrow} aria-hidden />
      </Link>
    </>
  )
}

export default FansRewardsWays
